import React from "react";
import { HashLink } from 'react-router-hash-link';
import { Zoom } from "react-reveal";
import { FcCalendar } from "react-icons/fc";
import { AiOutlineClockCircle } from "react-icons/ai";
import useAuth from "../../Hooks/useAuth";

const BlogItem = ({ blogItem }) => {
  const {
    id,
    blogThamble,
    blogTitle,
    blogPostUserName,
    blogPostUser,
    date,
    blogContent,
    minRead,
  } = blogItem;
  const {showDummyImage} = useAuth()
  return (
    <Zoom big duration={1500}>
        <div className="blog-item">
        <div className="blog-thumbnail">
          <img
            src={require(`../${process.env.REACT_APP_BLOG_IMAGE}${blogThamble}`)}
            alt={blogThamble}
            onError={({currentTarget},imageSize='270X155')=>showDummyImage({currentTarget},imageSize)}
          />
        </div>
        <div className="blog-content">
          <HashLink to={`/blogdetails/${id}/#header`}>
            <h4>{blogTitle}</h4>
          </HashLink>
          <div className="blog-meta">
            <div className="blog-user">
              <div className="blog-user-img">
                <img
                  src={require(`${process.env.REACT_APP_USER_IMAGE}${blogPostUser}`)}
                  alt={blogPostUser}
                  onError={({currentTarget},imageSize='18X18')=>showDummyImage({currentTarget},imageSize)}
                />
              </div>
              <h5>{blogPostUserName}</h5>
            </div>
            <div className="blog-date">
              <div className="blog-date-icon">
                <FcCalendar />
              </div>
              <span>{date}</span>
            </div>
            <div className="time">
              <div className="blog-time">
                <div className="blog-time-icon">
                  <AiOutlineClockCircle />
                </div>
                <span>{minRead}</span>
              </div>
            </div>
          </div>
          <p>{blogContent}</p>
        </div>
        </div>
    </Zoom>
  );
};

export default BlogItem;
